<!--  -->
<template>
  <div class="groupchat_box">
    <el-button style="margin-bottom:10px" type="success" icon="el-icon-plus" @click="groupchatcteat">群聊创建</el-button>
    <el-button style="margin-bottom:10px" type="success" icon="el-icon-plus" @click="authorizationfeishu">飞书授权</el-button>
    <el-button style="margin-bottom:10px" type="success" icon="el-icon-plus" @click="pullGroup">拉取外部群</el-button>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="chatId"
        label="聊天id"
        align="center"
        width="180"
      />
      <el-table-column
        prop="corpName"
        label="企业名称"
        align="center"
        width="180"
      />
      <el-table-column
        prop="name"
        label="群聊名称"
        width="180"
        align="center"
      />
      <el-table-column
        prop="userNum"
        label="人数"
        width="180"
        align="center"
      />
      <el-table-column
        prop="external"
        label="群类型"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.external=='2'?'外部群':'内部群' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="userNum"
        label="头像"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <img :src="scope.row.avatar" class="avatar_box" alt="">
        </template>
      </el-table-column>
      <el-table-column
        prop="webhook"
        label="机器人回调地址"
        width="180"
        align="center"
      />
      <!-- <el-table-column
        prop="official"
        label="绑定公众号"
        width="180"
      /> -->
      <!-- <el-table-column
        prop="official"
        label="成员"
        width="220"
        align="center"
      >
        <template slot-scope="scope">
          <div class="member_box">
            <div v-for="item,indexr in scope.row.users.list.slice(0,3)" :key="indexr" class="member_item">{{ item.name }}</div>
            <el-button v-if="scope.row.users.hasMore" type="text" @click="more(scope.row.users.list)">更多</el-button>
          </div>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="official"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <!-- <el-button type="primary" size="mini">删除</el-button> -->
          <el-button class="button-size" type="primary" size="mini" @click="groupmembers(scope.row)">查看群成员列表</el-button>
          <el-button type="success" size="mini" @click="deletechatapi(scope.row.id)">解散群聊</el-button>
          <el-button v-if="scope.row.external===2" type="primary" size="mini" @click="webhookapi(scope.row)">设置机器人地址</el-button>
        </template>

      </el-table-column>
    </el-table>
    <el-dialog
      title="更多成员"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="30%"
    >
      <moremembers ref="menberdom" />
    </el-dialog>
    <el-dialog
      title="设置机器人地址"
      :visible.sync="webhookRobot"
      width="30%"
      @close="roboturl= ''"
    >
      <el-form @submit.native.prevent="submit">
        <el-form-item>
          <div class="robot">
            <el-input v-model.trim="roboturl" type="textarea" @keyup.enter="submit" />
            <el-button style="margin-left:10px" type="primary" @click="submit">确定</el-button>
          </div>
        </el-form-item>
      </el-form>

    </el-dialog>
    <el-dialog
      title="群聊创建"
      :visible.sync="groupchatdialogVisible"
      :close-on-click-modal="false"
      width="30%"
    >
      <groupchatcteat ref="groupchatcteatdom" @createupdata="createupdata" />
    </el-dialog>
    <el-dialog
      :title="{ authorization: '飞书授权', pull: '拉取外部群' }[title]"
      :visible.sync="show"
      :close-on-click-modal="true"
      width="30%"
      @close="handleClose"
    >
      <authorization ref="authorization" :title="title" @createupdata="createupdata" />
    </el-dialog>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { groupchat, deletechat, feishuChatSetWebhook } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import moremembers from './components/moremembers.vue'
import authorization from './components/authorization.vue'
import groupchatcteat from './components/groupchatcteat.vue'
export default {
  name: 'Groupmanagement',
  components: {
    PaginationRight,
    moremembers,
    groupchatcteat,
    authorization
  },
  data() {
    return {
      title: '',
      query: {
        page: 1,
        pageSize: 10
      },
      total: null,
      tableData: [],
      dialogVisible: false,
      groupchatdialogVisible: false,
      show: false,
      webhookRobot: false,
      roboturl: '',
      robotrow: {}
    }
  },
  created() {
    this.groupchatlist()
  },
  mounted() {

  },
  methods: {
    async submit() {
      const regex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i
      // const regex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i
      if (regex.test(this.roboturl)) {
        await feishuChatSetWebhook({
          id: this.robotrow.id,
          webhook: this.roboturl
        })
        this.webhookRobot = !this.webhookRobot
        this.groupchatlist()
        this.$message({
          type: 'success',
          message: '添加成功!'
        })
      } else {
        this.roboturl = ''
        this.$message({
          type: 'info',
          message: '输入内容不为url格式!'
        })
      }
    },
    webhookapi(row) {
      this.robotrow = row
      this.roboturl = row.webhook
      this.webhookRobot = !this.webhookRobot
    },
    handleClose() {
      this.$refs.authorization.close()
    },
    pullGroup() {
      this.title = 'pull'
      this.show = !this.show
      this.$nextTick(() => {
        this.$refs.authorization.send()
      })
    },
    authorizationfeishu() {
      this.title = 'authorization'
      this.show = !this.show
      this.$nextTick(() => {
        this.$refs.authorization.send()
      })
    },
    async groupchatlist() {
      const data = await groupchat(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data.data)
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.groupchatlist()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.groupchatlist()
    },
    // more(item) {
    //   console.log('item', item)
    //   this.dialogVisible = true
    //   this.$nextTick(() => {
    //     this.$refs.menberdom.send(item)
    //   })
    // },
    groupmembers(item) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.menberdom.send(item)
      })
    },
    groupchatcteat() {
      this.groupchatdialogVisible = true
      this.$nextTick(() => {
        this.$refs.groupchatcteatdom.send()
      })
    },
    createupdata() {
      if (this.title === 'pull' || this.title === 'authorization') {
        this.show = false
      }
      this.groupchatdialogVisible = false
      this.groupchatlist()
    },
    deletechatapi(id) {
      this.$confirm('此操作将解散改群聊, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        deletechat({
          chat_key_id: id
        }).then((res) => {
          console.log('res', res)
          this.$message({
            type: 'success',
            message: '解散成功!'
          })
          this.groupchatlist()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    }

  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

.robot{
  display: flex;
}
.groupchat_box{
  padding: 20px;
}
.member_box{
  display: flex;
  align-items: center;
}
.member_item{
  margin-right: 10px;
}
.avatar_box{
  width: 50px;
  height: 50px;
}
</style>
